/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ConfigurationListResponse,
  ConfigurationResponse,
  CreateConfigurationRequest,
  UpdateConfigurationRequest,
} from '../models/index';
import {
    ConfigurationListResponseFromJSON,
    ConfigurationListResponseToJSON,
    ConfigurationResponseFromJSON,
    ConfigurationResponseToJSON,
    CreateConfigurationRequestFromJSON,
    CreateConfigurationRequestToJSON,
    UpdateConfigurationRequestFromJSON,
    UpdateConfigurationRequestToJSON,
} from '../models/index';

export interface DeleteRequest {
    tenantId: string;
    configurationId: string;
}

export interface CreateRequest {
    tenantId: string;
    createConfigurationRequest: CreateConfigurationRequest;
}

export interface GetRequest {
    tenantId: string;
    configurationId: string;
}

export interface ListRequest {
    tenantId: string;
}

export interface UpdateRequest {
    tenantId: string;
    configurationId: string;
    updateConfigurationRequest: UpdateConfigurationRequest;
}

/**
 * PublishedMDRDashboardApi - interface
 * 
 * @export
 * @interface PublishedMDRDashboardApiInterface
 */
export interface PublishedMDRDashboardApiInterface {
    /**
     * 
     * @summary Delete a published MDR dashboard configuration
     * @param {string} tenantId Tenant id
     * @param {string} configurationId Configuration id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PublishedMDRDashboardApiInterface
     */
    _deleteRaw(requestParameters: DeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ConfigurationResponse>>;

    /**
     * Delete a published MDR dashboard configuration
     */
    _delete(requestParameters: DeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ConfigurationResponse>;

    /**
     * Creates a tenant-scoped configuration of type PUBLISHED_MDR_DASHBOARD. The path tenantId is authoritative; request scope, tenantId, and configurationType are set by the server. 
     * @summary Create a published MDR dashboard configuration
     * @param {string} tenantId Tenant id
     * @param {CreateConfigurationRequest} createConfigurationRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PublishedMDRDashboardApiInterface
     */
    createRaw(requestParameters: CreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ConfigurationResponse>>;

    /**
     * Creates a tenant-scoped configuration of type PUBLISHED_MDR_DASHBOARD. The path tenantId is authoritative; request scope, tenantId, and configurationType are set by the server. 
     * Create a published MDR dashboard configuration
     */
    create(requestParameters: CreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ConfigurationResponse>;

    /**
     * 
     * @summary Get a published MDR dashboard configuration by id
     * @param {string} tenantId Tenant id
     * @param {string} configurationId Configuration id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PublishedMDRDashboardApiInterface
     */
    getRaw(requestParameters: GetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ConfigurationResponse>>;

    /**
     * Get a published MDR dashboard configuration by id
     */
    get(requestParameters: GetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ConfigurationResponse>;

    /**
     * 
     * @summary List published MDR dashboard configurations for a tenant
     * @param {string} tenantId Tenant id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PublishedMDRDashboardApiInterface
     */
    listRaw(requestParameters: ListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ConfigurationListResponse>>;

    /**
     * List published MDR dashboard configurations for a tenant
     */
    list(requestParameters: ListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ConfigurationListResponse>;

    /**
     * 
     * @summary Update a published MDR dashboard configuration
     * @param {string} tenantId Tenant id
     * @param {string} configurationId Configuration id
     * @param {UpdateConfigurationRequest} updateConfigurationRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PublishedMDRDashboardApiInterface
     */
    updateRaw(requestParameters: UpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ConfigurationResponse>>;

    /**
     * Update a published MDR dashboard configuration
     */
    update(requestParameters: UpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ConfigurationResponse>;

}

/**
 * 
 */
export class PublishedMDRDashboardApi extends runtime.BaseAPI implements PublishedMDRDashboardApiInterface {

    /**
     * Delete a published MDR dashboard configuration
     */
    async _deleteRaw(requestParameters: DeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ConfigurationResponse>> {
        if (requestParameters['tenantId'] == null) {
            throw new runtime.RequiredError(
                'tenantId',
                'Required parameter "tenantId" was null or undefined when calling _delete().'
            );
        }

        if (requestParameters['configurationId'] == null) {
            throw new runtime.RequiredError(
                'configurationId',
                'Required parameter "configurationId" was null or undefined when calling _delete().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/tenants/{tenantId}/published-mdr-dashboards/{configurationId}`;
        urlPath = urlPath.replace(`{${"tenantId"}}`, encodeURIComponent(String(requestParameters['tenantId'])));
        urlPath = urlPath.replace(`{${"configurationId"}}`, encodeURIComponent(String(requestParameters['configurationId'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ConfigurationResponseFromJSON(jsonValue));
    }

    /**
     * Delete a published MDR dashboard configuration
     */
    async _delete(requestParameters: DeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ConfigurationResponse> {
        const response = await this._deleteRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates a tenant-scoped configuration of type PUBLISHED_MDR_DASHBOARD. The path tenantId is authoritative; request scope, tenantId, and configurationType are set by the server. 
     * Create a published MDR dashboard configuration
     */
    async createRaw(requestParameters: CreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ConfigurationResponse>> {
        if (requestParameters['tenantId'] == null) {
            throw new runtime.RequiredError(
                'tenantId',
                'Required parameter "tenantId" was null or undefined when calling create().'
            );
        }

        if (requestParameters['createConfigurationRequest'] == null) {
            throw new runtime.RequiredError(
                'createConfigurationRequest',
                'Required parameter "createConfigurationRequest" was null or undefined when calling create().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/v1/tenants/{tenantId}/published-mdr-dashboards`;
        urlPath = urlPath.replace(`{${"tenantId"}}`, encodeURIComponent(String(requestParameters['tenantId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateConfigurationRequestToJSON(requestParameters['createConfigurationRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ConfigurationResponseFromJSON(jsonValue));
    }

    /**
     * Creates a tenant-scoped configuration of type PUBLISHED_MDR_DASHBOARD. The path tenantId is authoritative; request scope, tenantId, and configurationType are set by the server. 
     * Create a published MDR dashboard configuration
     */
    async create(requestParameters: CreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ConfigurationResponse> {
        const response = await this.createRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get a published MDR dashboard configuration by id
     */
    async getRaw(requestParameters: GetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ConfigurationResponse>> {
        if (requestParameters['tenantId'] == null) {
            throw new runtime.RequiredError(
                'tenantId',
                'Required parameter "tenantId" was null or undefined when calling get().'
            );
        }

        if (requestParameters['configurationId'] == null) {
            throw new runtime.RequiredError(
                'configurationId',
                'Required parameter "configurationId" was null or undefined when calling get().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/tenants/{tenantId}/published-mdr-dashboards/{configurationId}`;
        urlPath = urlPath.replace(`{${"tenantId"}}`, encodeURIComponent(String(requestParameters['tenantId'])));
        urlPath = urlPath.replace(`{${"configurationId"}}`, encodeURIComponent(String(requestParameters['configurationId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ConfigurationResponseFromJSON(jsonValue));
    }

    /**
     * Get a published MDR dashboard configuration by id
     */
    async get(requestParameters: GetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ConfigurationResponse> {
        const response = await this.getRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * List published MDR dashboard configurations for a tenant
     */
    async listRaw(requestParameters: ListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ConfigurationListResponse>> {
        if (requestParameters['tenantId'] == null) {
            throw new runtime.RequiredError(
                'tenantId',
                'Required parameter "tenantId" was null or undefined when calling list().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/tenants/{tenantId}/published-mdr-dashboards`;
        urlPath = urlPath.replace(`{${"tenantId"}}`, encodeURIComponent(String(requestParameters['tenantId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ConfigurationListResponseFromJSON(jsonValue));
    }

    /**
     * List published MDR dashboard configurations for a tenant
     */
    async list(requestParameters: ListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ConfigurationListResponse> {
        const response = await this.listRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update a published MDR dashboard configuration
     */
    async updateRaw(requestParameters: UpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ConfigurationResponse>> {
        if (requestParameters['tenantId'] == null) {
            throw new runtime.RequiredError(
                'tenantId',
                'Required parameter "tenantId" was null or undefined when calling update().'
            );
        }

        if (requestParameters['configurationId'] == null) {
            throw new runtime.RequiredError(
                'configurationId',
                'Required parameter "configurationId" was null or undefined when calling update().'
            );
        }

        if (requestParameters['updateConfigurationRequest'] == null) {
            throw new runtime.RequiredError(
                'updateConfigurationRequest',
                'Required parameter "updateConfigurationRequest" was null or undefined when calling update().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/v1/tenants/{tenantId}/published-mdr-dashboards/{configurationId}`;
        urlPath = urlPath.replace(`{${"tenantId"}}`, encodeURIComponent(String(requestParameters['tenantId'])));
        urlPath = urlPath.replace(`{${"configurationId"}}`, encodeURIComponent(String(requestParameters['configurationId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateConfigurationRequestToJSON(requestParameters['updateConfigurationRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ConfigurationResponseFromJSON(jsonValue));
    }

    /**
     * Update a published MDR dashboard configuration
     */
    async update(requestParameters: UpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ConfigurationResponse> {
        const response = await this.updateRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
